document.addEventListener('DOMContentLoaded', () => {
  const stickyContainer = document.getElementById('sticky-container');
  const hideTargets = document.querySelectorAll('.product [data-hide-sticky]');

  if (!stickyContainer || hideTargets.length === 0) return;

  const observer = new IntersectionObserver((entries) => {
    const isVisible = entries.some(entry => entry.isIntersecting);
    stickyContainer.classList.toggle('u-hidden', isVisible);
  }, {
    threshold: 0.1
  });

  hideTargets.forEach(target => observer.observe(target));
});



document.addEventListener('DOMContentLoaded', function () {
  const stickyBtn = document.querySelector('.block_producy-stickybtn');

  if (!stickyBtn) return;

  // Set initial state
  stickyBtn.style.display = 'none';

  // Offset thresholds
  const mobileOffset = 1000;  // px
  const desktopOffset = 1000; // px

  function getScrollThreshold() {
    return window.innerWidth <= 768 ? mobileOffset : desktopOffset;
  }

  function toggleStickyBtn() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (scrollTop > getScrollThreshold()) {
      stickyBtn.style.display = 'block';
    } else {
      stickyBtn.style.display = 'none';
    }
  }

  // Listen to scroll
  window.addEventListener('scroll', toggleStickyBtn);
});
